
export default class HeroPhrases {

    constructor() {

        this.settings = {
            phrases : $('.js-changing-phrases')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.phrases.length) {
            const phrases = document.querySelectorAll('.js-changing-phrases');
            let currentIndex = 0;

            const displayNextPhrase = () => {
                phrases[currentIndex].classList.add('hidden');
                currentIndex = (currentIndex + 1) % phrases.length;
                phrases[currentIndex].classList.remove('hidden');
            }

            setInterval(displayNextPhrase, 2500);
        }

    }

};

new HeroPhrases();